// extracted by mini-css-extract-plugin
export var FAQWrapper = "faq-module--FAQWrapper--a1cba";
export var title = "faq-module--title--29417";